import { useState, type FormEvent } from "react";
import { useStore } from "../store";

export function LoginScreen() {
  const login = useStore((s) => s.login);
  const busy = useStore((s) => s.authBusy);
  const error = useStore((s) => s.authError);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  function submit(e: FormEvent) {
    e.preventDefault();
    if (!busy) void login(email.trim(), password);
  }

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={submit}>
        <img src="/hle-icon.png" alt="" className="login-logo" />
        <h1>Sign in</h1>
        <p className="login-sub">Use your Hal Leonard Europe account to continue.</p>

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
        />

        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && <div className="login-err">{error}</div>}

        <button className="btn primary" type="submit" disabled={busy}>
          {busy ? "Signing in..." : "Sign in"}
        </button>
      </form>
    </div>
  );
}
